import React from 'react';

export default function ProductImage({
  className = null,
  img = 'https://cdn.foodrevolution.org/tt2/tt2-product-image-v20240207.png',
  width = '1500',
  height = '711',
  altText = 'Tackling Type 2 Course graphic',
  ...props
}) {
  return (
    <>
      <img className={className} src={img} width={width} height={height} alt={altText} />
    </>
  );
}
